import React, { useEffect } from "react";
import equipe from "../../assets/images/equipe.jpg";
import { Link } from "react-router-dom";

function AboutUsJeunes() {
    useEffect(() => {
      // set page title
      document.title = 'Qui sommes-nous ? - Parlons Règles';
      const metaDescriptionTag = document.querySelector('meta[name="description"]');
      if (metaDescriptionTag) {
        metaDescriptionTag.setAttribute('content', "Parlons Règles est un programme d’éducation menstruelle pensé et conçu par l’association Règles Élémentaires. Depuis 2015, Règles Élémentaires est l’association française de référence sur les règles.");
      }
    }, []);

    return (
      <div>
        <div className="about">
          <div className="about__text-container">
            <h2 className="about__title">
              Qui se cache<br/>
              <strong>
                <i>derrière Parlons Règles ?</i>
              </strong>
            </h2>
            <p className="about__text">
              Parlons Règles est un programme d’éducation menstruelle pensé et conçu par <b>l’association Règles Élémentaires</b>. Nous sommes une association qui agit pour <b>l’égalité, l’éducation</b> et la <b>justice menstruelles</b>, pour que les femmes et toutes les personnes qui ont, avaient et auront leurs règles puissent les vivre dignement, sans tabou et en sécurité.
            </p>
            <p className="about__text">
              Nous faisons des <b>collectes et redistribution de produits menstruels</b> dans toute la France. Mais pour <b>combattre le tabou</b> millénaire des règles, il faut aller plus loin ! Nous nous mobilisons aussi lors d’événements, de <b>grandes campagnes</b> de communication et de sensibilisation. Nous animons aussi des <b>ateliers scolaires</b> pour parler des règles aux jeunes, et des <b>formations pour accompagner des adultes</b> à mettre en place des projets sur les règles.
            </p>
            <p className="about__text">
              Grâce à des partenariats avec des équipes éducatives (enseignant·es, infirmier·es scolaires, etc), des parents, et des spécialistes de la santé menstruelle (médecin, sage-femmes, etc) nous avons pu développer des contenus sur cette plateforme Parlons Règles qui permettent d’aborder le <b>tabou et son histoire</b>, la <b>physiologie</b>, les <b>bons gestes</b> à adopter et nous répondons à toutes les questions des élèves.
            </p>
            <p className="about__text">
              Nous avons d’ailleurs des outils à destination des adultes de la communauté éducative (parents, profs, CPE, personnels médico-sociaux, éducateur·ices spécialisé·es, …), disponibles sur <Link to="/Relais" style={{textDecoration: 'underline'}} target="_blank">ParlonsRegles.fr/Relais</Link> et <Link to="/Parents" style={{textDecoration: 'underline'}} target="_blank">ParlonsRegles.fr/Parents</Link>. N’hésite pas à y envoyer les adultes de ton entourage !
            </p>
            <Link to="https://www.regleselementaires.com/" target="_blank" className="about__button">
              Découvrir l'association
            </Link> 
          </div>
          <div className="about__img-container">
            <img className="about__img" src={equipe} alt="19 personnes portant un t-shirt Règles Élémentaires" />
          </div>
        </div>  
      </div>
    );
  }

export default AboutUsJeunes;